export default __webpack_public_path__ + "3f642a92b6e57b3a4b84acb830f851b6.woff2";